export enum ProductEnum {
    OvertimeHVAC = 1,
    SubmeterBillding = 2,
}

export const ProductEnumNames = new Map<number, string>([
    [ProductEnum.OvertimeHVAC, 'On-demand HVAC'],
    [ProductEnum.SubmeterBillding, 'Submeter Billing']
]);
